import React, { useState, useEffect } from 'react';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import ListItemText from '@material-ui/core/ListItemText';
import Select from '@material-ui/core/Select';
import Checkbox from '@material-ui/core/Checkbox';
import Chip from '@material-ui/core/Chip';
import CheckIcon from '@material-ui/icons/Check';

const styles = (theme) => ({
    root: {},
    formControl: {
        margin: theme.spacing(1),
        minWidth: 120,
        maxWidth: 300,
    },
    chips: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    chip: {
        margin: 2,
    },
    noLabel: {
        marginTop: theme.spacing(3),
    },
});

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

const MultipleSelect = (props) => {
    const { t, classes, label, items, max } = props;
    const [options, setOptions] = useState([]);
    const [selectedItems, setSelectedItems] = useState([]);

    useEffect(() => {
        if (items) {
            setOptions(items);
        }
    }, [items]);

    const handleChange = (e) => {
        const selected = e.target.value;
        if (selected.length <= max) {
            setSelectedItems(selected);
        }
    };


    return (
        <>
            <FormControl className={classes.formControl}>
                <InputLabel id="multiple-item-label">{label}</InputLabel>
                <Select
                    labelId="multiple-item-label"
                    id="multiple-item-select"
                    multiple
                    value={selectedItems}
                    onChange={handleChange}
                    input={<Input />}
                    renderValue={(selected) => (
                        <div className={classes.chips}>
                        {selected.map((item) => (
                            <Chip
                                key={item.value}
                                label={item.name}
                                className={classes.chip}
                                color="primary"
                            />
                        ))}
                        </div>
                    )}
                    MenuProps={MenuProps}
                >
                {options.map((opt) => {
                    const isChecked = selectedItems.some((selected) => selected.value === opt.value);
                    return (
                        <MenuItem key={opt.value} value={opt}>
                            {/* <Checkbox checked={isChecked} /> */}
                            <ListItemText primary={opt.name} />
                            { isChecked? (<CheckIcon style={{ color: 'green' }} />):(null) }
                        </MenuItem>   
                    )
                })}
                </Select>
            </FormControl>
        </>
    );
};

const mapStateToProps = (state) => ({});

const mapDispatchToProps = (dispatch) => ({});

export default compose(connect(mapStateToProps, mapDispatchToProps), withStyles(styles))(MultipleSelect);
